import React from "react";
import BaseQuestionCard from "./../BaseQuestionCard";
import { QUESTION_CARD_VARIANTS } from "../constants/constantsSurveys";

export default function TextQuestionCard(props) {
  return (
    <BaseQuestionCard
      {...props}
      {...QUESTION_CARD_VARIANTS.text}
    />
  );
}
